export default __webpack_public_path__ + "static/media/ecosystem_log10.8ed12461.png";